module.exports = __webpack_public_path__ + "img/start_up 1.311899e7.svg";